import { render, staticRenderFns } from "./PlatformCampaign.vue?vue&type=template&id=6d4b9663&scoped=true&"
import script from "./PlatformCampaign.vue?vue&type=script&lang=js&"
export * from "./PlatformCampaign.vue?vue&type=script&lang=js&"
import style0 from "./PlatformCampaign.vue?vue&type=style&index=0&id=6d4b9663&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4b9663",
  null
  
)

export default component.exports